<template>
  <div class="feedBack_print_dialog">
    <custom-dialog class="afterSaleRole-item-dialog" width="1000px" :title="model.title" :visible="visible" v-on="$listeners">
      <div class="dialog-body" ref="print">
        <h3>{{ $t('asm_feedBack_print_dialog.zljzlfkbg') }}</h3>
        <p class="sub">
          <span>{{ $t('asm_feedBack_print_dialog.shen_qing_zu_zhi') }}:{{ info.applyOrgName ||'-' }}</span>
          <span>{{ $t('asm_feedBack_print_dialog.shen_qing_ren') }}:{{ info.creator ||'-' }}</span>
          <span>{{ $t('asm_feedBack_print_dialog.shen_qing_ri_qi') }}:{{ $momentLocal(info.gmtCreate, 'YYYY-MM-DD') }}</span>
        </p>
        <div class="line-title">{{ $t('asm_feedBack_print_dialog.gu_zhang_xin_xi') }}</div>
        <table border="1" style="border-collapse: collapse" class="table">
          <tr>
            <th class="key">{{ $t('asm_feedBack_print_dialog.chan_pin_xing_hao') }}</th>
            <th class="val">{{ info.productCode || '-' }}</th>
            <th class="key">{{ $t('asm_feedBack_print_dialog.ji_shen_hao') }}</th>
            <th class="val">{{ info.bodyNum || '-' }} {{getDicValue('order_device_biz_state', info.bizState)}}</th>
            <th class="key" style="width:13%">{{ $t('asm_feedBack_print_dialog.shou_ci_qi_zu_ri_qi') }}</th>
            <th class="val">{{ $momentLocal(info.firstRentalTime, 'YYYY-MM-DD') || '-' }}</th>
          </tr>
          <tr>
            <th class="key">{{ $t('asm_feedBack_print_dialog.ling_jian_bian_hao') }}</th>
            <th class="val">{{ info.partCode || '-' }}</th>
            <th class="key">{{ $t('asm_feedBack_print_dialog.ling_jian_ming_cheng') }}</th>
            <th class="val">{{ info.partName || '-' }}</th>
            <th class="key">{{ $t('asm_feedBack_print_dialog.ling_jian_lei_xing') }}</th>
            <th class="val">{{ getDicValue('asm_part_type', info.partType) || '-' }}</th>
          </tr>
          <tr>
            <th class="key">{{ $t('asm_feedBack_print_dialog.ling_jianSN') }}</th>
            <th class="val">{{ info.partSn || '-' }}</th>
            <th class="key">{{ $t('asm_feedBack_print_dialog.ling_jian_shu_liang') }}</th>
            <th class="val">{{ info.replaceNum || '-' }}</th>
            <th class="key">{{ $t('asm_feedBack_print_dialog.shi_fou_jin_shui') }}</th>
            <th class="val">{{ getDicValue('isynergy_cloud_bool', info.isSoak) || '-' }}</th>
          </tr>
          <tr>
            <th class="key">{{ $t('asm_feedBack_print_dialog.gu_zhang_miao_shu') }}</th>
            <th class="val" colspan="5">{{ info.feedBackDesc || '-' }}</th>
          </tr>
          <tr>
            <th class="key">{{ $t('asm_feedBack_print_dialog.gong_dan_miao_shu') }}</th>
            <th class="val" colspan="5">{{ info.workOrderDesc || '-' }}</th>
          </tr>
        </table>
        <div class="line-title">{{ $t('asm_feedBack_print_dialog.gong_dan_xin_xi') }}</div>
        <table border="1" style="border-collapse: collapse" class="table">
          <tr>
            <th class="key">{{ $t('asm_feedBack_print_dialog.gong_dan_bian_hao') }}</th>
            <th class="val">{{ info.workOrderCode || '-' }}</th>
            <th class="key">{{ $t('asm_feedBack_print_dialog.gong_dan_lei_xing') }}</th>
            <th class="val" >{{ getDicValue('asm_work_order_type', info.workOrderType) || '-' }}</th>
            <th class="key" style="width:13%">{{ $t('asm_feedBack_print_dialog.gong_dan_zhuang_tai') }}</th>
            <th class="val">{{ getDicValue('asm_work_order_state', info.workOrderState) || '-' }}</th>
          </tr>
          <tr>
            <th class="key">{{ $t('asm_feedBack_print_dialog.you_xian_ji') }}</th>
            <th class="val">{{ getDicValue('asm_close_priority', info.priority) || '-' }}</th>
            <th class="key">{{ $t('asm_feedBack_print_dialog.lai_yuan') }}</th>
            <th class="val">{{ info.workOrderSource || '-' }}</th>
            <th class="key">{{ $t('asm_feedBack_print_dialog.chuang_jian_fang_shi') }}</th>
            <th class="val">{{ getDicValue('asm_case_order_create_mode', info.createMode) || '-' }}</th>
          </tr>
          <tr>
            <th class="key">{{ $t('asm_feedBack_print_dialog.shou_hou_gong_si') }}</th>
            <th class="val" colspan="3">{{ info.afterServiceName || '-' }}</th>
            <th class="key">{{ $t('asm_feedBack_print_dialog.shgcs') }}</th>
            <th class="val">{{ info.technicianName || '-' }} {{ info.technicianPhone }}</th>
          </tr>
          <tr>
            <th class="key">{{ $t('asm_feedBack_print_dialog.shang_bao_ren') }}</th>
            <th class="val">{{ info.creator || '-' }}</th>
            <th class="key">{{ $t('asm_feedBack_print_dialog.shang_bao_shi_jian') }}</th>
            <th class="val">{{ $momentLocal(info.gmtCreate, 'YYYY-MM-DD') || '-' }}</th>
            <th class="key">{{ $t('asm_feedBack_print_dialog.he_tong_bian_hao') }}</th>
            <th class="val">{{ info.contractNo || '-' }}{{ getDicValue('crm_contract_type', info.orderType) }}</th>
          </tr>
          <tr>
            <th class="key">{{ $t('asm_feedBack_print_dialog.zu_lin_fang') }}</th>
            <th class="val" colspan="3">{{ info.customerName || '-' }}</th>
            <th class="key">{{ $t('asm_feedBack_print_dialog.xiang_mu') }}</th>
            <th class="val" >{{ info.locationName || '-' }}</th>
          </tr>
          <tr>
            <th class="key">{{ $t('asm_feedBack_print_dialog.xiang_mu_di_zhi') }}</th>
            <th class="val" colspan="5">{{ info.useLocation || '-' }}</th>
          </tr>
          <tr>
            <th class="key">{{ $t('asm_feedBack_print_dialog.shi_shi_di_zhi') }}</th>
            <th class="val" colspan="5">{{ info.gpsAddress || '-' }}</th>
          </tr>
        </table>

        <!-- <p>{{ $t('p_workorderFeedBack_bgscrq') }}：{{$momentLocal(now,'YYYY-MM-DD')}}</p> -->
        <div class="content">
          <div class="line-title">{{ $t('asm_feedBack_print_dialog.fan_kui_fen_xi') }}</div>
          <div class="item">
            <h4>
              {{ $t('asm_feedBack_print_dialog.yuan_yin_fen_xi') }}:
            </h4>
             <p>{{ (result.causeAnalysis && result.causeAnalysis.content) || '-' }}</p>
            <div class="footer">
              <p>
                <span class="lable">{{ $t('asm_feedBack_print_dialog.tian_xie_ren') }}：</span>
                {{ (result.causeAnalysis && result.causeAnalysis.optUser) || '-' }}
              </p>
              <p>
                <span class="lable">{{ $t('Common.com_date') }}：</span>
                {{ (result.causeAnalysis && $momentLocal(result.causeAnalysis.optTime, 'YYYY-MM-DD')) || '-' }}
              </p>
            </div>
          </div>
          <div class="item">
            <h4>
              {{ $t('asm_feedBack_print_dialog.gai_shan_cuo_shi') }}:
            </h4>
            <p>{{ (result.improveMethod && result.improveMethod.content) || '-' }}</p>
            <div class="footer">
              <p>
                <span class="lable">{{ $t('asm_feedBack_print_dialog.tian_xie_ren') }}：</span>
                {{ (result.improveMethod && result.improveMethod.optUser) || '-' }}
              </p>
              <p>
                <span class="lable">{{ $t('Common.com_date') }}：</span>
                {{ (result.improveMethod && $momentLocal(result.improveMethod.optTime, 'YYYY-MM-DD')) || '-' }}
              </p>
            </div>
          </div>
          <div class="item">
            <h4>
              {{ $t('asm_feedBack_print_dialog.chu_li_jie_guo') }}:
            </h4>
            <p>{{ (result.handleResultQc && result.handleResultQc.content) || '-' }}</p>
            <div class="footer">
              <p>
                <span class="lable">{{ $t('asm_feedBack_print_dialog.tian_xie_ren') }}：</span>
                {{ (result.handleResultQc && result.handleResultQc.optUser) || '-' }}
              </p>
              <p>
                <span class="lable">{{ $t('Common.com_date') }}：</span>
                {{ (result.handleResultQc && $momentLocal(result.handleResultQc.optTime, 'YYYY-MM-DD')) || '-' }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">{{ $t('Common.com_close') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
/**
 *
 */

import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  name: '',
  mixins: [dialogMixins],

  data() {
    return {
      info: {},
      result: {},
      imgList: [],
    };
  },
  computed: {
    // 是否展示图片
    showImg() {
      return this.imgList.length;
    },
    now() {
      return new Date();
    },
  },

  methods: {
    init() {
      // this.info = {};
      this.$getJSON(apis.feedbackInfo, { feedBackId: this.model.data.feedBackId }, true)
        .then((res) => {
          this.info = res.data;
        })
        .then(() => {
          setTimeout(() => {
            this.$print(this.$refs.print);
          }, 1000);
        });
      this.$getJSON(apis.feedbackApprovalResultInfo, {
        feedBackId: this.model.data.feedBackId,
      }).then((res) => {
        this.result = res.data;
      });
      this.$getFileList({ bizId: this.model.data.feedBackId, bizType: 'asm.feedBack.icon' }).then((list) => {
        this.imgList = list;
      });

      // 打印
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss">
.feedBack_print_dialog {
  padding: 16px;
  h3 {
    padding: 0 12px;
    text-align: center;
    font-size: 24px;
    font-weight: 500;
    color: #262626;
    line-height: 40px;
  }
  .sub {
    margin-top: 12px;
    span {
      margin-right: 24px;
      font-size: 13px;
      color: #262626;
      line-height: 17px;
    }
  }
  table {
    width: 100%;
    border:1px solid #333 ;
    th{
      font-size: 13px;
      color: #262626;
      font-weight: normal !important;
      text-align: left;
      padding:0 5px;
      // width: calc(100% /6);
    }
    .key{
      width: 12%;
    }
    .val{
      width:21.3%;
    }
  }
  .img-content {
    overflow: hidden;
    .img-item {
      float: left;
      margin-right: 15px;
      width: 100px;
      height: 100px;
      border-radius: 4px;
      border: 1px solid #ccc;
      position: relative;

      .img {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        max-width: 95%;
        max-height: 95%;
      }
    }
  }
  .el-col {
    font-size: 13px;
    color: #262626;
    line-height: 24px;
    span {
      color: #262626;
    }
  }
  .line-title {
    margin: 10px 0;
    line-height: 12px;
    font-size: 13px;
    color: #333;
    font-weight:bold
  }

  .item {
    margin-top: 10px;
    padding:10px;
    border: 1px solid #333;
    h4 {
      font-size: 13px;
      font-weight: 500;
      color: #262626;
      line-height: 20px;
      text-align: left;

    }
p {
   margin-top: 10px;
       color: #262626;
        font-size: 12px;
        text-align: left;
        margin-top: 5px;
        // padding-left: 5px;
        // text-indent: 4em;
      }
    .footer {
      display: flex;
      justify-content: flex-end;
      p {
        padding-right: 24px;
        text-align: right;
        color: #262626;
        font-size: 13px;
        .lable {
          font-weight: 500;
          color: #262626;
        }
      }
    }
  }
  .tips{
     margin: 10px 0;
    line-height: 12px;
    font-size: 13px;
   color: #262626;
  }
}
@media print {
  *noprint::after {
    content: '' !important;
  }
  // 去掉页眉 页尾
  .header,.footer{ display:none; }
  @page {
    // size: auto; /* auto is the initial value */
    // margin: 3mm; /* this affects the margin in the printer settings */
    size: A4 portrait;
    margin-bottom: 0mm;
  margin-top: 0mm;
    margin:0mm 1cm;
  }

  html {
    background-color: #ffffff;
    margin: 0px; /* this affects the margin on the html before sending to printer */
  }

  body {
    // border: solid 1px blue ;
    margin: 10mm 15mm 10mm 15mm; /* margin you want for the content */
  }
h3 {
    padding: 0 12px;
    text-align: center;
    font-size: 24px;
    font-weight: 500;
    color: #262626;
    line-height: 40px;
    margin-top: 1cm;
  }
  .sub {
    margin-top: 12px;
    span {
      margin-right: 24px;
      font-size: 13px;
      color: #262626;
      line-height: 17px;
    }
  }
  table {
    width: 100%;
    border:1px solid #333 ;
    th{
      font-size: 13px;
      color: #262626;
      font-weight: normal !important;
      text-align: left;
      padding:0 5px;
      // width: calc(100% /6);
    }
    .key{
      width: 10%;
    }
    .val{
      width:23.3%;
    }


  }
  .img-content {
    overflow: hidden;
    .img-item {
      float: left;
      margin-right: 15px;
      width: 100px;
      height: 100px;
      border-radius: 4px;
      border: 1px solid #ccc;
      position: relative;

      .img {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        max-width: 95%;
        max-height: 95%;
      }
    }
  }
  .el-col {
    font-size: 13px;
    color: #262626;
    line-height: 24px;
    span {
      color: #262626;
    }
  }
  .line-title {
    margin: 10px 0;
    line-height: 12px;
    font-size: 13px;
    color: #333;
    font-weight:bold
  }

  .item {
    margin-top: 10px;
    padding:10px;
    border: 1px solid #333;
    h4 {
      font-size: 13px;
      font-weight: 500;
      color: #262626;
      line-height: 20px;
      text-align: left;

    }
p {
   margin-top: 10px;
       color: #262626;
        font-size: 12px;
        text-align: left;
        margin-top: 5px;
        // padding-left: 5px;
        // text-indent: 4em;
      }
    .footer {
      display: flex;
      justify-content: flex-end;
      p {
        padding-right: 24px;
        text-align: right;
        color: #262626;
        font-size: 13px;
        .lable {
          font-weight: 500;
          color: #262626;
        }
      }
    }
  }
  .tips{
     margin: 10px 0;
    line-height: 12px;
    font-size: 13px;
   color: #262626;
  }
}
</style>
